module.exports = __webpack_public_path__ + "static/media/7.a63b1356.jpg";